import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IsotopesViewer from '../../../elements/IsotopesViewer';
const styles = {
    groupContainer: {
        padding: '5px',
        borderRadius: '5px',
        margin: '10px 0px',
        backgroundColor: 'white',
    },
    header: {
        borderBottom: '1px solid #e8e8e8',
        paddingBottom: '5px',
        fontWeight: 'bold',
        color: '#4a4a4a',
    },
};
export function NucleusGroup({ nucleus, children, renderTop, renderBottom, }) {
    return (_jsxs("div", { style: styles.groupContainer, children: [_jsx(IsotopesViewer, { style: styles.header, value: nucleus }), renderTop?.(), children, renderBottom?.()] }, nucleus));
}
